import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';

const MyTeam = () => {
  const [pageSetting, setPageSetting] = useState(null);
  const [team, setTeam] = useState([]);

  // Fetch page settings
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await fetch("https://notesmania.in/api/theme_setting/TeamSetting.php");
        const result = await response.json();

        if (result.success && result.data) {
          setPageSetting(result.data);
        } else {
          console.error("Invalid or null data from API");
        }
      } catch (err) {
        console.error("Settings fetch error:", err);
      }
    };

    fetchSettings();
  }, []);

  // Fetch team members
  useEffect(() => {
    const fetchTeam = async () => {
      try {
        const response = await fetch("https://notesmania.in/api/website_team.php");
        const result = await response.json();

        if (result.success && result.data) {
          setTeam(result.data);
        } else {
          console.error("Invalid or null team data from API");
        }
      } catch (err) {
        console.error("Team fetch error:", err);
      }
    };

    fetchTeam();
  }, []);

  return (
    <div className="pt-20">
      <div className="text-center w-full md:w-2/3 m-auto px-4">
        {pageSetting?.title && (
          <>
            <h1 className="text-3xl font-semibold text-black">{pageSetting.title}</h1>
            <span className="text-sm mt-2 block text-gray-600">{pageSetting.bio}</span>
          </>
        )}
      </div>

      <section className="mt-10 px-4">
        {team && team.length > 0 ? (
          <Swiper
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
            autoplay={{ delay: 2000 }}
            modules={[Autoplay]}
            breakpoints={{
              640: { slidesPerView: 1 },
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 3 },
            }}
          >
            {team.map((member, index) => {
              if (!member) return null;

              return (
                <SwiperSlide key={index}>
                  <div className="card text-center p-4 shadow-lg rounded-lg bg-white">
                    <div className="img-container mb-4">
                      <img
                        src={`https://notesmania.in/api/${member.thumbnail ?? 'default.jpg'}`}
                        alt={member.TeamName ?? "Team member"}
                        className="w-24 h-24 object-cover rounded-full mx-auto"
                      />
                    </div>
                    <h3 className="text-lg font-semibold text-black">{member.TeamName ?? "Unknown"}</h3>
                    <p className="text-sm text-gray-600">{member.ShortBio ?? ""}</p>
                    <div className="icons mt-3 flex justify-center gap-3">
                      {member.links
                        ? JSON.parse(member.links).map((link, i) => (
                            <a
                              key={i}
                              href={`https://${link.url}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-xl text-blue-500 hover:text-blue-700"
                              dangerouslySetInnerHTML={{ __html: link.icon }}
                            />
                          ))
                        : null}
                    </div>
                  </div>
                </SwiperSlide>
              );
            })}
          </Swiper>
        ) : (
          <p className="text-center text-gray-500">Loading team data...</p>
        )}
      </section>
    </div>
  );
};

export default MyTeam;
